import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type Props = {
  user: any | null;
  onLogin: () => void;
  onSignOut: () => void;
  onPreferences: () => void;
};

export const UserMenu = ({ user, onLogin, onSignOut, onPreferences }: Props) => {
  if (!user) {
    return (
      <Button size="sm" onClick={onLogin}>
        Log in
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="flex items-center gap-2">
          {user.user_metadata?.full_name ?? user.email}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6}>
        <DropdownMenuItem onSelect={onPreferences}>Preferences</DropdownMenuItem>
        <DropdownMenuItem onSelect={onSignOut}>Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
